import {Injectable} from '@angular/core';
import {Constant} from "../../common/constant";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FileSaverService } from 'ngx-filesaver';
import { createRequestBody, createRequestOption } from 'src/app/common/utils/request-util';
import { map } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class AgentService {
  resourceAdminUrl = environment.urlBackEnd + '/agents/admin';
  constructor(
    private http: HttpClient,
    private fileSaverService: FileSaverService
  ){}

  getCountryMarket(currencyCode) {
      return new Promise<any>(resolve => {
        this.http.get(environment.urlBackEnd +  Constant.api_issuer_country_market + currencyCode)
          .subscribe((res: any)=>{
            if (res.status === Constant.success_code) {
              resolve(res.data)
            }
          })
      })
  }
  countKYCPriority() {
    return this.http.get(environment.urlBackEnd + Constant.api_count_list_kyc_priority);
  }
  countRegisterTrade() {
    return this.http.get(environment.urlBackEnd + Constant.api_count_list_register_trade);
  }
  countChangeRequest() {
    return this.http.get(environment.urlBackEnd + Constant.api_count_list_change_request);
  }
  countPendingOrder() {
    return this.http.get(environment.urlBackEnd + Constant.api_count_pending_order);
  }
  countRegisterSIP() {
    return this.http.get(environment.urlBackEnd + Constant.api_count_register_sip);
  }
  countForeignInvestor() {
    return this.http.get(environment.urlBackEnd + Constant.api_count_foreign_investor);
  }
  getOrders(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_agent_name_orders, body);
  }
  updateProfile(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_user_update_profile, body)
  }
  updateAvatar(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_user_update_avatar, body)
  }
  updateMail(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_user_update_mail, body)
  }
  updateMail1(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_security_change_mail_1, body)
  }
  updateMail2(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_security_change_mail_2, body)
  }
  updatePhoto(body) {
    return  this.http.post(environment.urlBackEnd +  Constant.api_user_update_photos, body)
  }
  getProductById(id) {
    return this.http.get(environment.urlBackEnd + Constant.api_common_products_id + id);
  }
  getOrder(data) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_orders, data);
  }
  getOrderApproveAll(data) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_order_approve_all_summary, data);
  }
  getOrderAcceptAll(data) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_order_accept_all_summary, data);
  }
  pledge(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_product_pledge, body);
  }
  cancelPledge(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_product_cancel_pledge, body);
  }
  acceptProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_accept_profile, body);
  }
  approveProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_approve_profile, body);
  }
  cancelProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_cancel_profile, body);
  }
  removeProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_remove_profile + body.profileId, body);
  }
  changeStatusProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_update_status_profile, body);
  }
  rejectProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_profile_reject + body.id, body);
  }
  createFileUpload(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_update_create_file_to_vsd, body);
  }
  updateToVSD(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_update_update_to_vsd, body);
  }
  approveChangeProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_change_request_profile_approve, body);
  }
  getThirdApps(body) {
    return this.http.post(environment.urlBackEnd + '/agents/get-third-apps', body);
  }
  sign(body) {
    return this.http.post(environment.urlBackEnd + '/agents/investment-profiles/sign', body);
  }
  print(body) {
    return this.http.post(environment.urlBackEnd + '/agents/investment-profiles/print', body);
  }
  delete(id) {
    return this.http.delete(environment.urlBackEnd + '/agents/investor/' + id);
  }
  processSIP() {
    return this.http.post(environment.urlBackEnd + '/agents/sip/processing', {});
  }
  finishSIP() {
    return this.http.post(environment.urlBackEnd + '/agents/sip/finished', {});
  }
  uploadHSBC(body) {
    return this.http.post(environment.urlBackEnd + '/agents/investment-profile/upload-hsbc-account-number', body);
  }
  
  getAgentIssuers(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_common_agent_issuer, body);
  }
  getInvestorList(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_investors_list, body);
  }
  getInvestorListNotUpdate(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_investor_profile_pending, body);
  }
  getInvestorListOnVSD(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_approve_profiles, body);
  }
  getInvestorListPendingOnVSD(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_approve_profiles, body);
  }
  getInvestorListKYC(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_investor_profile_pending, body);
  }
  getProfileSurveyIPO(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_document_survey_ipo, body);
  }
  getChangeProfile(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_change_request_profile_filter, body);
  }
  getRegisterSip(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_agent_register_sip, body);
  }
  getAgentTransactionHistory(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_transaction_history, body);
  }
  previewTransferAssetIn(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_transfer_asset_in_preview, body);
  }
  transferAssetIn(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_transfer_asset_in, body);
  }
  previewTransferAssetOut(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_transfer_asset_out_preview, body);
  }
  transferAssetOut(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_transfer_asset_out, body);
  }
  getTransferAssetHistory(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_transfer_asset_filter, body);
  }
  getHoldingAssetOfUser(body) {
    const url = Constant.api_agent_holding_asset_user.replace('{profileNumber}', body.profileNumber);
    return this.http.get(environment.urlBackEnd + url);
  }
  getTransactionDetail(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_transaction_detail, body);
  }
  getSources(body) {
    return this.http.post(environment.urlBackEnd + '/agents/get-sources', body);
  }
  getEKYCLogList(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_agent_ekyc_log_list, body);
  }
  getEKYCManualList(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_agent_ekyc_manual_list, body);
  }
  countEKYCManualList() {
    return  this.http.get(environment.urlBackEnd + Constant.api_agent_count_ekyc_manual_list);
  }
  getListSignDocumentUpdateProfile(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_agent_list_sign_document_update_profile, body);
  }
  approveSignDocumentUpdateProfile(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_approve_sign_document_update_profile, body);
  }
  getInvestorChangeNameList(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_agent_investor_change_name_list, body);
  }
  approveInvestorChangeName(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_agent_approve_investor_change_name, body);
  }
  getProducts(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_common_agent_products_filter, body);
  }
  getIssuers(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_common_agent_issuer, body);
  }
  getCalculateFeeForIssuer(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_calculate_fee_issuer, body);
  }
  getCalculateFeeForPartner(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_calculate_fee_partner, body);
  }
  exportCalculateFee(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_export_calculate_fee, body);
  }
  getStatisticGoldTransaction(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_get_statistic_gold_transaction, body);
  }
  exportStatisticGoldTransaction(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_export_statistic_gold_transaction, body);
  }
  getAssetReport(body) {
    return  this.http.post(environment.urlBackEnd + Constant.api_asset_report, body);
  }
  exportIdCard(data) {
    return this.http.post(environment.urlBackEnd + Constant.api_export_id_card, data, {responseType:'blob',  observe: 'events'})
    .pipe(map((res: any) => {
        if (res.body) {
            this.fileSaverService.save(res.body, res.headers.get('filename'));    
        }
        return res.type !== 0;
    }))
  }
  exportManulife(data) {
    return this.http.post(environment.urlBackEnd + Constant.api_export_manulife, data, {responseType:'blob',  observe: 'events'})
    .pipe(map((res: any) => {
        if (res.body) {
            this.fileSaverService.save(res.body, res.headers.get('filename'));    
        }
        return res.type !== 0;
    }))
  }
  exportFile(url, data) {
    return this.http.post(environment.urlBackEnd + url, data, {responseType:'blob',  observe: 'events'})
    .pipe(map((res: any) => {
        if (res.body) {
            this.fileSaverService.save(res.body, res.headers.get('filename'));    
        }
        return res.type !== 0;
    }))
  }
  importTransaction(formData) {
    return this.http.post(environment.urlBackEnd + Constant.api_import_transaction, formData, {responseType:'blob',  observe: 'events'})
    .pipe(map((res: any) => {
      if (res.body) {
          this.fileSaverService.save(res.body, res.headers.get('filename'));    
      }
      return res.type !== 0;
    }))
  }
  queryLocation(req?: any) {
    const options = createRequestOption(req);
    return this.http.get(this.resourceAdminUrl + '/dataProvince/', { params: options, observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  changeStatusInvestor(userId, statusId) {
    const body = { statusId};
    return this.http.patch<any[]>(this.resourceAdminUrl + `/user/status/${userId}`, body , { observe: 'response' });
  }
  findInvestor(id: number) {
    return this.http.get<any>(`${this.resourceAdminUrl}/user/${id}`, { observe: 'response' });
  }
  updateInvestor(userId, body: any): any {
    return this.http.patch<any>(this.resourceAdminUrl + `/user/investor/${userId}/`, body, { observe: 'response' });
  }
  queryInvestors(req?: any){
    const body = createRequestBody(req);
    return this.http.post(this.resourceAdminUrl + '/user/list/', body,  {  observe: 'response' });
  }
  queryStatus(typeCode?) {
    const req = {
      typeCode: typeCode || 'USER',
      page: 1,
      size: 30
    }
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceAdminUrl + '/status/',  { params: options, observe: 'response' })
    .pipe(map((res: any) => {
      const result = res.body.data;
      return result;
    }));
  }
  approveAllChangeProfile(body) {
    return this.http.post(environment.urlBackEnd + `/agents/investment-profile-change-requests/approve-all-for-user`, body , { observe: 'response' });
  }
  findCurrentName(userCode) {
    return this.http.get(environment.urlBackEnd + `/agents/users/${userCode}`);
  }
  createChangeNameRequest(body) {
    return this.http.post(environment.urlBackEnd + `/agents/users-update-name/create-request-confirm-name`, body , { observe: 'response' });
  }
  getReceivedProfile(userId) {
    return this.http.get(environment.urlBackEnd + `/agents/users/get-document?userId=${userId}&typeCode=DKGD_FINCORP`);
  }
  uploadDocumentProfile(formData) {
    return this.http.post(environment.urlBackEnd + `/agents/users/upload-document`, formData);
  }
}
